import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: -15px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
  }
`;

export const Copy = styled.div`
  margin: 15px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    /* max-width: 300px; */
    max-width: 350px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
  }
`;

export const Spinner = styled.div`
  margin: 15px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    max-width: 550px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 820px;
  }
`;

export const Number = styled.p`
  color: ${themeGet('colors.pc-red', '#E1251B')};
  font-weight: ${themeGet('fontWeights.bold')};
  font-size: 37px;
  letter-spacing: 1.51px;
  font-variant-numeric: tabular-nums;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    font-size: 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 64px;
    letter-spacing: 2.1px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    font-size: 105px;
    letter-spacing: 3.48px;
  }
`;
